import { Inbox } from 'lucide-react';

import type { CandidateOriginApi } from '@/modules/candidates/types';

/** A tag after the name of someone who applied through the careers page. */
export function InboundBadge({ origin }: { origin: CandidateOriginApi }) {
  if (origin !== 'Inbound') return null;
  return (
    <span className="bg-secondary-150 text-primary-700 inline-flex h-5 shrink-0 items-center gap-1 rounded-[4px] px-1.5 text-xs font-medium whitespace-nowrap">
      <Inbox aria-hidden className="size-3" />
      Inbound
    </span>
  );
}
